// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2-95L","dragIcon":"SortableItem_dragIcon__3Mr9i","disabled":"SortableItem_disabled__3-9ei"};